// extracted by mini-css-extract-plugin
export var cartText = "CartFooter_cartText__jwZi2";
export var container = "CartFooter_container__X4e9d";